// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen {
  .status-select {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 105;
    transition: all 0.3s;
    transform: translateX(100%);
  }
  .status-select.active {
    transform: translateX(0);
  }
  app-select-list {
    width: 100%;
    min-height: 34px;
  }
  app-select-list .current-status {
    position: relative;
    font-size: 14px;
  }
  app-select-list .current-status:before {
    content: "";
    height: xrem(12px);
    width: xrem(12px);
    border-radius: 2px;
    display: inline-block;
    margin-right: 0.5rem;
    position: relative;
    top: 1px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/vehicles/vehicle-status-selector/vehicle-status-selector.component.scss"],"names":[],"mappings":"AACA;EAEI;IACI,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,SAAA;IACA,YAAA;IACA,oBAAA;IACA,2BAAA;EADN;EAKE;IACI,wBAAA;EAHN;EAME;IACI,WAAA;IACA,gBAAA;EAJN;EAKM;IACI,kBAAA;IACA,eAAA;EAHV;EAKU;IACI,WAAA;IACA,kBAAA;IACA,iBAAA;IAEA,kBAAA;IACA,qBAAA;IACA,oBAAA;IACA,kBAAA;IACA,QAAA;EAJd;AACF","sourcesContent":["\r\n@media only screen {\r\n\r\n    .status-select {\r\n        position: fixed;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        z-index: 105;\r\n        transition: all 0.3s;\r\n        transform: translateX(100%);\r\n\r\n    }\r\n\r\n    .status-select.active {\r\n        transform: translateX(0);\r\n    }\r\n\r\n    app-select-list {\r\n        width: 100%;\r\n        min-height: 34px;\r\n        .current-status {\r\n            position: relative;\r\n            font-size: 14px;\r\n\r\n            &:before {\r\n                content: '';\r\n                height: xrem(12px);\r\n                width: xrem(12px);\r\n                // @include border-radius(xrem(2px));\r\n                border-radius: 2px;\r\n                display: inline-block;\r\n                margin-right: 0.5rem;\r\n                position: relative;\r\n                top: 1px;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
